import NavBar from './navbar';
import NavMenu from './navmenu';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLocationDot, faPhone, faSync } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import * as UI from '../slices/uiSlice';
import * as Cases from '../slices/casesSlice';
import * as Forms from '../slices/formsSlice';
import { useEffect } from 'react';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import hub_logo from '../assets/Main_Hub_Icon_Large.svg';
import { useMediaQuery } from 'react-responsive';
import OpenCaseIconBlue from '../assets/open-case-icon-blue.svg';
import CaseDetailsIcon from '../assets/case-details-icon.svg';
import ActionsIconBlue from '../assets/actions-icon-blue.svg';
import FormsAndReportsIconBlue from '../assets/forms-and-reports-icon-blue.svg';
import MeetTheTeamIconBlue from '../assets/meet-the-team-icon-blue.svg';
import WishlistIconBlue from '../assets/wishlist-icon-blue.svg';
import ClientIconMale from '../assets/client-icon-male.svg';
import ClientIconFemale from '../assets/client-icon-female.svg';
import HomeIcon from '../assets/home-icon.svg';
import PhoneIcon from '../assets/phone-icon.svg';
import MailIcon from '../assets/mail-icon.svg';

const CaseDetails = () => {
    const cases = useAppSelector(state => state.cases);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleMediaQueryChange = (matches: boolean) => {
    }

    const isTabletOrMobile = useMediaQuery({ maxWidth: 1024, orientation: 'portrait' }, undefined, handleMediaQueryChange);

    const openCase = () => {
        navigate('/case');
    }

    const openCaseDetails = () => {
        navigate('/case-details');
    }

    const openActions = () => {
        navigate('/actions');
    }

    const openHistory = () => {
        navigate('/historylist');
    }

    const openTeam = () => {
        navigate('/team');
    }

    const wishList = () => {
        if (cases.case.details && cases.case.details.wishlisted) {
            dispatch(UI.setWishlistEditPopup({ visible: true, caseno: cases.case.caseno, casetype: cases.case.type }));
        } else {
            dispatch(UI.setWishlistPopup({ visible: true, caseno: cases.case.caseno, casetype: cases.case.type }));
        }
    }

    const getTeam = (): Cases.teamState | null => {
        for (const team of cases.teams) {
            if (cases.case.details && (team.handler === cases.case.details.handler)) {
                return team;
            }
        }
        return null;
    }

    const team: Cases.teamState | null = getTeam();

    useEffect(() => {
        dispatch(Forms.setFormValueWithId({
            form: 'ICD',
            type: 'text',
            id: 'valuation_booked',
            val: (cases.case.IntroducerDates.valuation_booked != null ? cases.case.IntroducerDates.valuation_booked : '')
        }));
        dispatch(Forms.setFormValueWithId({
            form: 'ICD',
            type: 'text',
            id: 'mortgage_completed',
            val: (cases.case.IntroducerDates.mortgage_completed != null ? cases.case.IntroducerDates.mortgage_completed : '')
        }));
        dispatch(Forms.setFormValueWithId({
            form: 'ICD',
            type: 'text',
            id: 'valuation_completed',
            val: (cases.case.IntroducerDates.valuation_completed != null ? cases.case.IntroducerDates.valuation_completed : '')
        }));
    }, [cases.case.IntroducerDates, dispatch]);

    useEffect(() => {
		if (!cases.case.caseno) {
			navigate('/hub');
		}
	}, [])

    return (
        <div className="Home" style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
                <div className='OrangeBand'>
                    <div style={{ marginLeft: 'calc(10% + 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', overflow: 'hidden' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img style={{ width: 96, marginRight: 8 }} src={hub_logo} alt='Hub-Logo' />
                            <div style={{ marginLeft: 24 }}>
                                <div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(isTabletOrMobile ? 'Reference' : 'Client Reference Number')} - {cases.case.caseno}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row100 topButtonContainer" style={{ justifyContent: 'start', alignItems: 'end', position: 'absolute', top: '150px', left: '2%', zIndex: 995 }}>
                    <div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', overflow: 'hidden' }} onClick={() => openCase()}>
                        <div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
                            <img style={{ width: 20, height: 20, marginRight: 8 }} src={OpenCaseIconBlue} alt='Milestones-Icon' />
                            <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Milestones</div>
                        </div>
                        <div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                            {cases.isOpeningActions &&
                                <FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
                            }
                        </div>
                    </div>
                    <div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openCaseDetails()}>
                        <div style={{ display: 'flex', alignItems: 'center', minWidth: '45px' }}>
                            <img style={{ width: 20, height: 20, marginRight: 8 }} src={CaseDetailsIcon} alt='CaseDetails-Icon' />
                            <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Case Details</div>
                        </div>
                        <div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                            {cases.isOpeningActions &&
                                <FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
                            }
                        </div>
                    </div>
                    <div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openActions()}>
                        <div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
                            <img style={{ width: 20, height: 20, marginRight: 8 }} src={ActionsIconBlue} alt='Actions-Icon' />
                            <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Actions</div>
                            {cases.case.details && cases.case.details.unviewActions.length > 0 && <div style={{ height: '19px', width: '19px', marginLeft: '10px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{cases.case.details.unviewActions.length}</div>}
                        </div>
                        <div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                            {cases.isOpeningActions &&
                                <FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
                            }
                        </div>
                    </div>
                    <div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openHistory()}>
                        <div style={{ display: 'flex', alignItems: 'center', minWidth: '50px' }}>
                            <img style={{ width: 20, height: 20, marginRight: 8 }} src={FormsAndReportsIconBlue} alt='Forms&Reports-Icon' />
                            <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Forms & Reports</div>
                        </div>
                        <div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                            {cases.isOpeningActions &&
                                <FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
                            }
                        </div>
                    </div>
                    <div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openTeam()}>
                        <div style={{ display: 'flex', alignItems: 'center', minWidth: '50px' }}>
                            <img style={{ width: 20, height: 20, marginRight: 8 }} src={MeetTheTeamIconBlue} alt='Team-Icon' />
                            <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Meet the Team</div>
                        </div>
                        <div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                            {cases.isOpeningTeam &&
                                <FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
                            }
                        </div>
                    </div>
                    <div className={(cases.case.details?.wishlisted ? 'buttonGreenRounded' : 'buttonPurpleSecondary')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => wishList()}>
                        <div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
                            <img style={{ width: 20, height: 20, marginRight: 8 }} src={WishlistIconBlue} alt='Wishlist-Icon' />
                            <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Wishlist{(cases.case.details?.wishlisted ? ' - ' + cases.case.details.wishlisted : '')}</div>
                        </div>
                        <div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                            {cases.isWishlisting &&
                                <FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
                            }
                        </div>
                    </div>
                </div>

                <div className='caseDetailsContainer'>
                    <div className="caseDetailsContainerTop">
                        <div className='caseDetailsContainerTopBox' style={{ height: '24px', position: 'relative', left: '4px' }}>
                            <h5>{cases.case.description}</h5>
                        </div>

                        <p style={{ position: 'relative', left: '4px' }}>Team Name: {team?.teamname}</p>

                        <div className='caseDetailsContainerTopBox'>
                            <div style={{ display: 'flex', textAlign: 'center', flex: '24px 0 0', justifyContent: 'center', alignItems: 'center' }}>
                                <FontAwesomeIcon style={{ fontSize: 18 }} icon={faLocationDot} />
                            </div>
                            <p>{cases.case.property?.address}</p>
                        </div>

                        <div className='caseDetailsContainerTopBox'>
                            <div style={{ display: 'flex', textAlign: 'center', flex: '24px 0 0', justifyContent: 'center', alignItems: 'center' }}>
                                <FontAwesomeIcon style={{ fontSize: 18 }} icon={faEnvelope} />
                            </div>
                            <a href={"mailto:" + team?.email} target="_blank" rel="noopener noreferrer">{team?.email ?? 'Not Available'}</a>
                        </div>

                        <div className='caseDetailsContainerTopBox'>
                            <div style={{ display: 'flex', textAlign: 'center', flex: '24px 0 0', justifyContent: 'center', alignItems: 'center' }}>
                                <FontAwesomeIcon style={{ fontSize: 18 }} icon={faPhone} />
                            </div>
                            <p>{team?.phone ?? 'Not Available'}</p>
                        </div>
                    </div>

                    <div className='caseDetailsContainerBottom'>
                        <h3 className='caseDetailsContainerBottomHeading'>Client Details</h3>

                        <div className="caseDetailsContainerBottomMain">
                            <div className="caseDetailsContainerBottomBox">
                                <div className='caseDetailsBoxTop'>
                                    <img src={cases.case.client1?.title === "Mr" ? ClientIconMale : ClientIconFemale} alt="Client-Icon" className='caseDetailsBoxTopIcon' />
                                    <p className='caseDetailsBoxTopText'>Client 1</p>
                                </div>

                                <div className='caseDetailsBoxMiddle'>{cases.case.client1?.title} {cases.case.client1?.firstname} {cases.case.client1?.lastname}</div>

                                <div className="caseDetailsBoxBottom">
                                    <div className="caseDetailsBoxBottomData">
                                        <img src={HomeIcon} alt="Home-Icon" style={{ height: '16px', width: '16px' }} />
                                        <p style={{ maxHeight: '63px', height: 'max-content', width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px' }}>
                                            {cases.case.client1?.address1}, {cases.case.client1?.address2}, {cases.case.client1?.address3}, {cases.case.client1?.address4}, {cases.case.client1?.postcode}.
                                        </p>
                                    </div>

                                    <div className="caseDetailsBoxBottomData">
                                        <img src={PhoneIcon} alt="Phone-Icon" style={{ height: '16px', width: '16px' }} />
                                        <p style={{ width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px', textDecoration: 'underline' }}>
                                            {cases.case.client1?.mobile ?? 'Not Available'}
                                        </p>
                                    </div>

                                    <div className="caseDetailsBoxBottomData">
                                        <img src={MailIcon} alt="Mail-Icon" style={{ height: '16px', width: '16px' }} />
                                        <a href={"mailto:" + cases.case.client1?.email} style={{ width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px', textDecoration: 'underline' }}>
                                            {cases.case.client1?.email ?? 'Not Available'}
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {cases.case.client2 && <div className="caseDetailsContainerBottomBox">
                                <div className='caseDetailsBoxTop'>
                                    <img src={cases.case.client2?.title === "Mr" ? ClientIconMale : ClientIconFemale} alt="Client-Icon" className='caseDetailsBoxTopIcon' />
                                    <p className='caseDetailsBoxTopText'>Client 2</p>
                                </div>

                                <div className='caseDetailsBoxMiddle'>{cases.case.client2?.title} {cases.case.client2?.firstname} {cases.case.client2?.lastname}</div>

                                <div className="caseDetailsBoxBottom">
                                    <div className="caseDetailsBoxBottomData">
                                        <img src={HomeIcon} alt="Home-Icon" style={{ height: '16px', width: '16px' }} />
                                        <p style={{ maxHeight: '63px', height: 'max-content', width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px' }}>
                                            {cases.case.client2?.address1}, {cases.case.client2?.address2}, {cases.case.client2?.address3}, {cases.case.client2?.address4}, {cases.case.client2?.postcode}.
                                        </p>
                                    </div>

                                    <div className="caseDetailsBoxBottomData">
                                        <img src={PhoneIcon} alt="Phone-Icon" style={{ height: '16px', width: '16px' }} />
                                        <p style={{ width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px', textDecoration: 'underline' }}>
                                            {cases.case.client2?.mobile ?? 'Not Available'}
                                        </p>
                                    </div>

                                    <div className="caseDetailsBoxBottomData">
                                        <img src={MailIcon} alt="Mail-Icon" style={{ height: '16px', width: '16px' }} />
                                        <a href={"mailto:" + cases.case.client2?.email} style={{ width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px', textDecoration: 'underline' }}>
                                            {cases.case.client2?.email ?? 'Not Available'}
                                        </a>
                                    </div>
                                </div>
                            </div>}

                            {cases.case.client3 && <div className="caseDetailsContainerBottomBox">
                                <div className='caseDetailsBoxTop'>
                                    <img src={cases.case.client3?.title === "Mr" ? ClientIconMale : ClientIconFemale} alt="Client-Icon" className='caseDetailsBoxTopIcon' />
                                    <p className='caseDetailsBoxTopText'>Client 3</p>
                                </div>

                                <div className='caseDetailsBoxMiddle'>{cases.case.client3?.title} {cases.case.client3?.firstname} {cases.case.client3?.lastname}</div>

                                <div className="caseDetailsBoxBottom">
                                    <div className="caseDetailsBoxBottomData">
                                        <img src={HomeIcon} alt="Home-Icon" style={{ height: '16px', width: '16px' }} />
                                        <p style={{ maxHeight: '63px', height: 'max-content', width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px' }}>
                                            {cases.case.client3?.address1}, {cases.case.client3?.address2}, {cases.case.client3?.address3}, {cases.case.client3?.address4}, {cases.case.client3?.postcode}.
                                        </p>
                                    </div>

                                    <div className="caseDetailsBoxBottomData">
                                        <img src={PhoneIcon} alt="Phone-Icon" style={{ height: '16px', width: '16px' }} />
                                        <p style={{ width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px', textDecoration: 'underline' }}>
                                            {cases.case.client3?.mobile ?? 'Not Available'}
                                        </p>
                                    </div>

                                    <div className="caseDetailsBoxBottomData">
                                        <img src={MailIcon} alt="Mail-Icon" style={{ height: '16px', width: '16px' }} />
                                        <a href={"mailto:" + cases.case.client3?.email} style={{ width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px', textDecoration: 'underline' }}>
                                            {cases.case.client3?.email ?? 'Not Available'}
                                        </a>
                                    </div>
                                </div>
                            </div>}

                            {cases.case.client4 && <div className="caseDetailsContainerBottomBox">
                                <div className='caseDetailsBoxTop'>
                                    <img src={cases.case.client4?.title === "Mr" ? ClientIconMale : ClientIconFemale} alt="Client-Icon" className='caseDetailsBoxTopIcon' />
                                    <p className='caseDetailsBoxTopText'>Client 4</p>
                                </div>

                                <div className='caseDetailsBoxMiddle'>{cases.case.client4?.title} {cases.case.client4?.firstname} {cases.case.client4?.lastname}</div>

                                <div className="caseDetailsBoxBottom">
                                    <div className="caseDetailsBoxBottomData">
                                        <img src={HomeIcon} alt="Home-Icon" style={{ height: '16px', width: '16px' }} />
                                        <p style={{ maxHeight: '63px', height: 'max-content', width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px' }}>
                                            {cases.case.client4?.address1}, {cases.case.client4?.address2}, {cases.case.client4?.address3}, {cases.case.client4?.address4}, {cases.case.client4?.postcode}.
                                        </p>
                                    </div>

                                    <div className="caseDetailsBoxBottomData">
                                        <img src={PhoneIcon} alt="Phone-Icon" style={{ height: '16px', width: '16px' }} />
                                        <p style={{ width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px', textDecoration: 'underline' }}>
                                            {cases.case.client4?.mobile ?? 'Not Available'}
                                        </p>
                                    </div>

                                    <div className="caseDetailsBoxBottomData">
                                        <img src={MailIcon} alt="Mail-Icon" style={{ height: '16px', width: '16px' }} />
                                        <a href={"mailto:" + cases.case.client4?.email} style={{ width: '222px', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', bottom: '1px', fontSize: '14px', textDecoration: 'underline' }}>
                                            {cases.case.client4?.email ?? 'Not Available'}
                                        </a>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>

            <div className='mainFooter'>
                <div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
                    <img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
                </div>
            </div>
            <div className='loginFooter'></div>
            <NavMenu />
            <NavBar />
        </div>
    );
}

export default CaseDetails;